import React, { Component } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { NavLink } from "react-router-dom";
import TagManager from 'react-gtm-module';
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import Popup from "reactjs-popup";
import axios from "axios";
import LazyLoad from "react-lazyload";
// import background from "../../../assets/img/chose-interestbg.jpg";

import {
  getImgUrl,
  getUrl,
  getWeather,
  asyncgetWeather,
  limitText,
  geinstagramData,
  isMobile,
} from "../../Utility/Utility";

import {
  Img,
  HomeTitle,
  InstagremSliderItem,
  FaqItem,
  HomeSlider,
  AnimateCallToAction,
  TravelAlert,
  BoxLink,
  HomeDeals,
  ParalaxBg,
  IsraelExpert,
  VideoCover,
} from "../../Components/UI/UI";

import { faqData } from "../../Data/Data";
import RecommendedItinerariesMice from "../../Components/RecommendedItineraries/RecommendedItinerariesMice";
import RecommendedItineraries2 from "../../Components/RecommendedItineraries/RecommendedItineraries2";
import TptTabsMice from "../../Components/TptTabs/TptTabsMice";
import TptTabsMob from "../../Components/TptTabsMob/TptTabsMob";
import Resources from "../../Components/Resources/Resources";
import ResourcesMob from "../../Components/ResourcesMob/ResourcesMob";

// import AgreeCookies from '../../Components/AgreeCookies/AgreeCookies'
import Form from "../../Components/Form/Form";
import Footer from "../../Components/Footer/Footer";
import SimpleSlider from "../../Components/SimpleSlider/SimpleSlider";

import "./InterestsMice.css";
import MenuHome from "../../Components/Menu/MenuHome";

// private class data

function Shuffle(o) {
  for (
    var j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o;
}

const getParam = window.location.search;
//console.log(typeof getParam);
//console.log(getParam);

class Home extends Component {
  constructor(props) {
    super(props);
    this.playVideo = this.playVideo.bind(this);
    this.playVideo2 = this.playVideo2.bind(this);
    this.playVideo3 = this.playVideo3.bind(this);
    this.playVideo4 = this.playVideo4.bind(this);
    this.state = {
      isVidClick: false,
      instagramData: [],
      instagramDataMobile: [],
      northArrMobile: [],
      // isLoading : true;
      // exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
      // exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
      exporeTelAvivAndjerusalemMainVid: "FYtk8JMMZRE",
      eurovisionMainVid: "5PAjhoH0NWU",
      TelAvivAndjerusalemVideoState: 0,
      culinaryVid: "jfyHxk8ZRrI",
      culinaryVidState: 0,
      faq: faqData,
      telAvivWeather: 20,
      waterTemp: 20,
      jerusalemWeather: 20,
      deadSeaWeather: 15,
      shirCssClass: " btn-shir",
      supportCssClass: " new-support-btn",
      open: false,
      instagramId: null,
      instagramUserImg: null,
      instagramCaption: null,
      instagramUserName: null,
      instagramLikes: null,
      imageState: true,
      imageState2: true,
      imageState3: true,
      imageState4: true,
      imageState5: true,
      imageState6: true,
      imageState7: true,
      imageState8: true,
      imageState9: true,
      imageState10: true,
      width: 0,
      MobileVidId1: "",
      MobileVidId1Elm: "",
      MobileVidId2: "",
      MobileVidId2Elm: "",

      MobileVidId3: "",
      MobileVidId3Elm: "",
      isInit: true,
      text1: "Travel Alert: Get the latest travel alerts impacting Israel",
      text2: " here",
      text3: "",
      coronaVirus: "/Pages/CoronaVirusPage",
    };
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }
  updateDimensions = () => {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName("body")[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    // height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

    this.setState({ width: width });
  };
  componentWillUnmount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
  }

  componentDidMount() {
    Promise.all([asyncgetWeather(), geinstagramData()]).then((response) => {
      const weather = response[0];
      const instagramData = response[1];

      this.setState({
        instagramData: instagramData.posts,
        deadSeaWeather: weather.deadsea.temperature,
        jerusalemWeather: weather.jerusalem.temperature,
        telAvivWeather: weather.telaviv.temperature,
        waterTemp: weather.telaviv.water_temp,
      });
    });

    var hash = window.location.hash;
    //console.log('hash: ', hash);
    var the_id = hash.substring(1);
    //console.log('the_id: ', the_id);

    if (hash) {
      var element = document.getElementById(the_id);
      var offset = 200;
      var viewportOffset = element.getBoundingClientRect();
      const top = viewportOffset.top;
      const newTop = top + offset;
      scroll.scrollMore(newTop, {
        duration: 1500,
        delay: 100,
        smooth: true,

        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    }

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
  }

  openModal = (id) => {
    var url = getUrl() + "instagram-api.php?ID=" + id;

    // var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
    axios.get(url, {}).then((res) => {
      var obj = res.data;

      var userinfo = obj.graphql.shortcode_media;
      var likes = userinfo.edge_media_preview_like.count;
      var username = userinfo.owner.username;
      var caption = userinfo.edge_media_to_caption.edges[0].node.text;
      var userProfileImg = userinfo.owner.profile_pic_url;

      // console.log(username);

      this.setState({
        open: true,
        instagramId: id,
        instagramUserImg: userProfileImg,
        instagramCaption: caption,
        instagramUserName: username,
        instagramLikes: likes,
      });
    });
  };
  closeModal = () => {
    this.setState({ open: false });
  };

  handleScroll = (event) => {
    let y = window.scrollY,
      shirCssClass = "",
      supportCssClass;
    if (y > 300) {
      shirCssClass = " btn-shir show-from-left";
      supportCssClass = " new-support-btn show-from-right";
    } else {
      shirCssClass = " btn-shir";
      supportCssClass = " new-support-btn";
    }
    this.setState({
      shirCssClass: shirCssClass,
      supportCssClass: supportCssClass,
    });
  };

  //This was added for mobile youtube butn play
  playVideo = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState: false,
    });
  };
  playVideo2 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState2: false,
    });
  };
  playVideo3 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState3: false,
    });
  };
  playVideo4 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState4: false,
    });
  };
  playVideo5 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState5: false,
    });
  };
  playVideo6 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState6: false,
    });
  };
  playVideo7 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState7: false,
    });
  };

  playVideo8 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState8: false,
    });
  };

  playVideo9 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState9: false,
    });
  };

  playVideo10 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState10: false,
    });
  };

  closeAlert = (event) => {
    document.getElementById("travel-alert").style.display = "none";
    document.getElementById("interests-main-paralax").style.marginTop =
      "25.5vw";
  };
  setVideoMobile = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId1: vidId, MobileVidId1Elm: id });
  };

  setVideoMobile2 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId2: vidId, MobileVidId2Elm: id });
  };

  setVideoMobile3 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId3: vidId, MobileVidId3Elm: id });
  };

  setVideo = (vidId, ctg) => {
    // alert("ss");
    if (
      ctg === "culinary" ||
      ctg === "culinarytelaviv" ||
      ctg === "culinaryjerusalem" ||
      ctg === "culinarynorth"
    ) {
      this.setState({ culinaryVid: vidId });
      const e = document.getElementById("CULINARY");

      scroll.scrollTo(e.offsetTop - 100);

      if (isMobile) {
        this.setState({
          imageState7: false,
        });
      }
    } else {
      const elm = document.getElementById("expore-tel-aviv-and-jerusalem");

      scroll.scrollTo(elm.offsetTop - 100);
      this.setState({ exporeTelAvivAndjerusalemMainVid: vidId });

      if (isMobile) {
        this.setState({
          imageState8: false,
        });
      }
    }
  };

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find((o) => {
      return o.id === id;
    });
    if (current.isOpen === true) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq: faq,
    });
  };

  handleisVidClick = () => {
    this.setState({
      isVidClick: !this.state.isVidClick,
    });
  };

  render() {
    const sliderSettings = {
      dots: true,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 1,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const sliderSettings2 = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const sliderSettings3 = {
      dots: false,
      autoplay: false,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 1,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            dots: false,
            autoplay: false,
            // lazyLoad: 'ondemand',
            infinite: true,
            lazyLoad: "ondemand",
            cssEase: "linear",
            slidesToShow: this.props.items != undefined ? this.props.items : 1,
            slidesToScroll: 1,
            arrows: true,
          },
        },

        {
          breakpoint: 600,
          settings: {
            dots: false,
            autoplay: false,
            // lazyLoad: 'ondemand',
            infinite: true,
            lazyLoad: "ondemand",
            cssEase: "linear",
            slidesToShow: this.props.items != undefined ? this.props.items : 1,
            slidesToScroll: 1,
            arrows: true,
          },
        },
      ],
    };

    const faqHtml = this.state.faq.map((o) => {
      return (
        <FaqItem
          q={o.q}
          key={o.id}
          answer={o.answer}
          isOpen={o.isOpen}
          click={() => {
            this.setCurrentFaq(o.id);
          }}
        />
      );
    });
    let instagramHtml = null;
    let callToActionHtml = "";

    callToActionHtml = (
      <div>
        <AnimateCallToAction
          src={"btn_shir_desk1.png"}
          srcMob={"btn_shir_mob.png"}
          cssClass={this.state.shirCssClass}
          link={"https://walla.co.il"}
        />
      </div>
    );

    var instagramData = this.state.instagramData;
    // console.log('instagramData: ' , instagramData);

    var insta_size = 1;
    // if ( this.state.width < 1000 ) {
    //     size = 4;
    // }
    if (this.state.width < 600) {
      insta_size = 4;
    }
    if (instagramData.length > 0) {
      while (instagramData.length > 0) {
        this.state.instagramDataMobile.push(
          instagramData.splice(0, insta_size)
        );
      }
    }

    if (this.state.instagramDataMobile.length > 0) {
      instagramHtml = this.state.instagramDataMobile.map((arr, i) => {
        return arr.map((o, i) => {
          var imgLink = "instagram/" + o.id + ".jpg";

          if (this.state.width < 600) {
            imgLink = "instagram/Mobile/" + o.id + ".jpg";
          }
          return (
            <div
              key={o.publishBy}
              onClick={() => {
                this.openModal(o.id);
              }}
            >
              {" "}
              <InstagremSliderItem
                title={o.publishBy}
                cssClass={"InstagremSliderItem-" + i}
                img={imgLink}
              />
            </div>
          );
        });
      });
      // console.log('instagramHtml2' , instagramHtml2);
      instagramHtml = instagramHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const currentInstagramLikeUrl =
      "https://www.instagram.com/p/" + this.state.instagramId + "/";
    const currentInstagramUrl =
      "https://www.instagram.com/" + this.state.instagramUserName + "/";
    const currentInstagramImgUrl =
      "instagram/" + this.state.instagramId + ".jpg";

    let a = (
      <div>
        <HomeSlider
          isHomeSlider={true}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
      </div>
    );

    let responsiveUrl = isMobile()
      ? `url(${process.env.PUBLIC_URL + "/assets/img/Mice/cover/M.jpg"})`
      : `url(${process.env.PUBLIC_URL + "/assets/img/Mice/cover/1.jpg"})`;

    return (
      <div className="page align-center page-interests page-interests-mice">
        {callToActionHtml}
        <MenuHome />
        <TravelAlert
          toLink={this.state.coronaVirus}
          click={this.closeAlert}
          placeText1={this.state.text1}
          placeText2={this.state.text2}
          placeText3={this.state.text3}
        />

        {/* <CoverSection
          desktopImg={'/Interests/cover/1.jpg'}
          mobileImg={'/Interests/cover/M.jpg'}
          cssClass={'interests-page'}
          pageTitleRowUp={'CHRISTIAN'}
          pageTitleRowDown={'INTEREST'}
       />*/}
        <VideoCover
          vidId={"eoeOj6WlrqY"}
          titleRowOne={"MICE"}
          titleRowTwo={"INTEREST"}
        />
        {/* <ParalaxBg
          titleRowOne={"MICE"}
          cssClass={"interests-page"}
          titleRowTwo={"INTEREST"}
          id={"interests-main-paralax"}
          style={{
            backgroundImage: responsiveUrl,
          }}
        /> */}

        <section
          className="home-section home-section-padding ac-customize-trip"
          id="customize-trip"
        >
          <div className="container">
            <HomeTitle cssClass="ac-black">
              CUSTOMIZE
              <br className="ac-show-on-cell" /> YOUR TRIP
            </HomeTitle>
            <div className="ac-inner-container">
              <BrowserView>
                <div className="ac-boxlink-desk">
                  <BoxLink
                    isRecomItine={false}
                    link={"#travel-planning"}
                    linkBlank={"_self"}
                    isImgLink={true}
                    wrapperCss={"1"}
                    img={"Custom_your_t/mice/desktop/travelplannigtool.jpg"}
                    title={"TRAVEL PLANNING TOOLS"}
                    imgArrowBlack={"arrowbright.svg"}
                    imgArrowWhite={"arrowwright.svg"}
                  />
                  <BoxLink
                    isRecomItine={false}
                    link={"#recommended-itineraries"}
                    linkBlank={"_self"}
                    isImgLink={true}
                    wrapperCss={"2"}
                    img={"Custom_your_t/mice/desktop/benefits.jpg"}
                    title={"BENEFITS"}
                    imgArrowBlack={"arrowbright.svg"}
                    imgArrowWhite={"arrowwright.svg"}
                  />
                  <BoxLink
                    isRecomItine={false}
                    link={"#resources"}
                    linkBlank={"_self"}
                    isImgLink={true}
                    wrapperCss={"3"}
                    img={"Custom_your_t/mice/desktop/resources.jpg"}
                    title={"RESOURCES"}
                    imgArrowBlack={"arrowbright.svg"}
                    imgArrowWhite={"arrowwright.svg"}
                  />
                  <BoxLink
                    isRecomItine={false}
                    link={"https://agents.israel.travel/Pages/ContactUs"}
                    isImgLink={true}
                    wrapperCss={"4"}
                    img={"Custom_your_t/mice/desktop/findyourpoint.jpg"}
                    title={"FIND YOUR POINT OF CONTACT"}
                    imgArrowBlack={"arrowbright.svg"}
                    imgArrowWhite={"arrowwright.svg"}
                  />
                </div>
              </BrowserView>
              <MobileView>
                <div className="ac-boxlinkmob-slider">
                  <SimpleSlider settings={sliderSettings3}>
                    <div>
                      <BoxLink
                        isRecomItine={false}
                        link={"#travel-planning"}
                        linkBlank={"_self"}
                        isImgLink={true}
                        wrapperCss={"1"}
                        img={"Custom_your_t/mice/mobile/travelplannigtool.jpg"}
                        title={"TRAVEL PLANNING TOOLS"}
                        imgArrowBlack={"arrowbright.svg"}
                        imgArrowWhite={"arrowwright.svg"}
                      />
                    </div>
                    <div>
                      <BoxLink
                        isRecomItine={false}
                        link={"#recommended-itineraries"}
                        linkBlank={"_self"}
                        isImgLink={true}
                        wrapperCss={"2"}
                        img={"Custom_your_t/mice/mobile/benefits.jpg"}
                        title={"BENEFITS"}
                        imgArrowBlack={"arrowbright.svg"}
                        imgArrowWhite={"arrowwright.svg"}
                      />
                    </div>
                    <div>
                      <BoxLink
                        isRecomItine={false}
                        link={"#resources"}
                        linkBlank={"_self"}
                        isImgLink={true}
                        wrapperCss={"3"}
                        img={"Custom_your_t/mice/mobile/resources.jpg"}
                        title={"RESOURCES"}
                        imgArrowBlack={"arrowbright.svg"}
                        imgArrowWhite={"arrowwright.svg"}
                      />
                    </div>
                    <div>
                      <BoxLink
                        isRecomItine={false}
                        link={"https://agents.israel.travel/Pages/ContactUs"}
                        isImgLink={true}
                        wrapperCss={"4"}
                        img={"Custom_your_t/mice/mobile/findyourpoint.jpg"}
                        title={"-	FIND YOUR POINT OF CONTACT"}
                        imgArrowBlack={"arrowbright.svg"}
                        imgArrowWhite={"arrowwright.svg"}
                      />
                    </div>
                  </SimpleSlider>
                </div>
              </MobileView>
            </div>
          </div>
        </section>

        <section
          className="home-section home-section-padding ac-israel-expert"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/Interests/israel-expert.jpg"})`,
          }}
          id="israel-expert"
        >
          <div className="container">
            <IsraelExpert />
          </div>
        </section>

        {/* <section
          className="home-section home-section-padding ac-travel-planning"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/Interests/travel-planning.jpg"})`,
          }}
          id="travel-planning"
        >
          <div className="container">
            <HomeTitle cssClass="ac-white">TRAVEL PLANNING TOOLS</HomeTitle>
            <div className="ac-inner-container">
              <IconTravelLink
                link={"#"}
                isIconLinkHoverd={"false"}
                wrapperCss={"1"}
                img={"airlines.png"}
                imgHover={"airlineshover.png"}
                title={"AIRLINES"}
              />
              <IconTravelLink
                link={"https://info.goisrael.com/en/accomodations"}
                isIconLinkHoverd={"false"}
                wrapperCss={"2"}
                img={"hotel.png"}
                imgHover={"hotelhover.png"}
                title={"ACCOMMODATION"}
              />
              <IconTravelLink
                link={
                  "https://israeltravel.co.il/%d7%9e%d7%a0%d7%92%d7%a0%d7%95%d7%9f-%d7%97%d7%99%d7%a4%d7%95%d7%a9-%d7%9e%d7%90%d7%a8%d7%92%d7%a0%d7%99-%d7%aa%d7%99%d7%99%d7%a8%d7%95%d7%aa/?languageSelector=%D7%90%D7%A0%D7%92%D7%9C%D7%99%D7%AA+%28English%29#!/"
                }
                isIconLinkHoverd={"false"}
                wrapperCss={"3"}
                img={"touroperator.png"}
                imgHover={"touroperatorhover.png"}
                title={"TOUR OPERATOR"}
              />
            </div>
          </div>
        </section> */}

        {/* <section
          className="home-section home-section-padding ac-guaranteed-departures"
          id="guaranteed-departures"
        >
          <div className="container">
            <HomeDeals title={"GUARANTEED DEPARTURES"} category="general" />
          </div>
        </section> */}
        {/* <section
          className="home-section home-section-padding ac-guaranteed-departures"
          id="guaranteed-departures"
        >
          <div className="container">
            <a href="#travel-planning">
              <HomeTitle cssClass="ac-black">TRAVEL PLANNING TOOLS</HomeTitle>
            </a>
          </div>
        </section> */}

        <section
          className="home-section home-section-padding ac-recommended-itineraries"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/recommended-itineraries.jpg"})`,
          }}
          id="recommended-itineraries"
        >
          <div className="container">
            <HomeTitle cssClass="ac-black"> BENEFITS </HomeTitle>
            <div className="ac-inner-container">
              <RecommendedItinerariesMice />
              {/* <RecommendedItineraries2 /> */}
            </div>
          </div>
        </section>

        <section
          className="home-section home-section-padding ac-resources"
          id="resources"
        >
          <div className="container">
            <HomeTitle cssClass="ac-black">RESOURCES</HomeTitle>
            <p className="ac-description">
              Here are some materials for you{" "}
              <br className="ac-show-on-mobile" />
              to use to be better at selling Israel
            </p>
            <div className="ac-inner-container">
              <BrowserView>
                {" "}
                <Resources category={"mice"} />
              </BrowserView>
              <MobileView>
                <ResourcesMob category={"mice"} />
              </MobileView>
            </div>
          </div>
        </section>

        {/* <LazyLoad height={200} once offset={50}>
          <section
            className="home-section home-section-padding ac-somebg"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL +
                "/assets/img/Interests/someBg.jpg"})`,
            }}
            id="somebg"
          >
            {/*<Img desktopImg={'Interests/someBg.jpg'} mobileImg={'someBg.jpg'} />*/}
        {/*  </section>
        </LazyLoad>*/}

        {/* <LazyLoad height={200} once offset={50}>
          <section
            className="home-section home-section-padding ac-things-todo"
            id="things-todo"
          >
            <div className="container-flued">
              <HomeTitle cssClass="ac-black">Sites of significance </HomeTitle>
              <div className="ac-inner-container">
                <ThingsToDo />
              </div>
            </div>
          </section>
        </LazyLoad> */}
        <section className="home-section home-section-padding" id="form">
          <div className="container">
            <div className="ac-outter-col ac-outter-col-1">
              <HomeTitle>
                <strong>SIGN UP HERE FOR UPDATES</strong>
                <br />
                FROM THE ISRAEL MINISTRY OF TOURISM
              </HomeTitle>
              <Form />
            </div>
            <div className="ac-outter-col ac-outter-col-2">
              <Img desktopImg="icons-form.png" mobileImg="icons-form.png" />
            </div>
          </div>
        </section>
        <section
          className="home-section home-section-padding ac-travel-planning"
          id="travel-planning"
        >
          <div className="container">
            <HomeTitle cssClass="ac-black">
              TRAVEL <br className="ac-show-on-cell" /> PLANNING TOOLS <br />
            </HomeTitle>
            {/* <small className="ac-sub-maintitle">
              I would like to have some text please.
            </small> */}
            <div className="ac-inner-container">
              <TptTabsMice />
              <TptTabsMob />
            </div>
          </div>
        </section>

        <LazyLoad height={200} once offset={400}>
          <Footer />
        </LazyLoad>

        {/* <section
          className="home-section home-section-padding ac-commingsoon"
          id="commingsoon"
        >
          <div className="container">
            <h1>Coming Soon</h1>
          </div>
        </section> */}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/InterestsMice/InterestsMice.js